
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Dropdown,
  Space,
  DatePicker,
  Tooltip,
  Button,
  Checkbox,
  Modal,
  Table,
  Drawer,
  Radio,
} from "antd";
import {
  DeleteTwoTone,
  FileExcelFilled,
  DownloadOutlined,
  EditOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import emptyIcon from "../../../../../images/empty.png";
import shareIcon from "../../../../../images/shareIcon.png";
import facebook from "../../../../../images/social/facebook.svg";
import twitter from "../../../../../images/social/twitter.svg";
import linkedin from "../../../../../images/social/linkedin.svg";
import embedIcon from "../../../../../images/embed-icon.svg";

import deleteIcon from "../../../../../images/training/delete-red.png";
import rtbmenu from "../../../../../images/training/rtb-menu.png";

import embedImageOption1 from "../../../../../images/embed-img/embedImageOption1.png";
import embedImageOption2 from "../../../../../images/embed-img/embedImageOption2.png";

import info from "../../../../../images/info.png";

import { notify } from "../../../../../components/Snack";

import { useParams, useHistory, useLocation } from "react-router-dom";

import {
  getCollections,
  createCollection,
  deleteCollection,
  exportCollection,
} from "../../../../../redux/actions/collections";
import {
  createCollectionV2,
  getCollectionsV2,
  deleteCollectionV2,
  exportCollectionV2,
  updateCollection,
  getListModels
} from "../../../../../redux/actions/collectionsV2";

import {
  getAllApiTokens,
  generateApiAccessToken,
} from "../../../../../redux/actions/auth";

import Loader from "../../../../../components/loader";
import $ from "jquery";
import moment from "moment";

const Collections = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [collections, setCollections] = useState([]);
  const [collectionName, setCollectionName] = useState("");
  const [liveSearchUrl, setLiveSearchUrl] = useState([""]);
  const [baseLanguage, setBaseLanguage] = useState("en");
  const [collectionDescription, setCollectionDescription] = useState("");

  const [listModels, setListModels] = useState([]);

  const [exportCsvName, setExportCsvName] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateFilter, setDateFilter] = useState(false);

  const [tokenFlag, setTokenFlag] = useState(false);
  const [model, setModel] = useState("");
  const [selectedOption, setSelectedOption] = useState("files");
  const [selectedLiveSearch, setSelectedLiveSearch] = useState("web_scrape");
  
  const [databaseType, setDatabaseType] = useState("");
  const [hostName, setHostName] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [port, setPort] = useState("");
  const [databaseName, setDatabaseName] = useState("");
  const [isSSL, setIsSSL] = useState(false);
  const [advancedSettings, setAdvancedSettings] = useState(false);
  const [advancedSettingsOption, setAdvancedSettingsOption] = useState(1);

  const [dbSchemas, setDbSchemas] = useState("");
  const [useTablesList, setUseTablesList] = useState("");
  const [useViewsList, setUseViewsList] = useState("");
  const [neglectViewList, setNeglectViewList] = useState("");
  const [neglectTableList, setNeglectTableList] = useState("");

  const [showDatabaseFields, setShowDatabaseFields] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null);
  const [resposeLang, setResponseLang] = useState(null);

  // Add this state for error message
  const [nameError, setNameError] = useState("");

  const dispatch = useDispatch();

  const userDetails = useSelector(
    (state) => state.organizationReducer.currentOrganization
  );
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  const token = useSelector(
    (state) => state.authReducer?.allTokensList[0]?.token
  );

  const text = `{
    chatFontSize: string;
    userChatBgColor: string;\n
    botChatBgColor: string;\n
    brandColor: string;\n
    greetingMsg: string;\n
    userIcon: string;\n
    botIcon: string;\n
    accentColor: string;\n
    brandIcon: string;\n
    headerMsg1: string;\n
    headerMsg2: string;\n
    headerMsg1Color: string;\n
    headerMsg2Color: string;\n
    userFontColor: string;\n
    botFontColor: string;\n
    floatingIcon: string;\n
    showUserIcon: boolean;
    showBotIcon: boolean;
    userIconBgColor: string;\n
    botIconBgColor: string;\n
    userIconPadding: string;\n
    botIconPadding: string;\n
    showBrandBorder: boolean;
    chatWidgetMinHeight: string;\n
    chatWidgetMaxHeight: string;\n
    chatWidgetCloseIconColor: string;\n
    chatBackgroundColor: string;\n
    chatWidgetWidth: string;\n
    typingMsg: string;\n
    floatingIconSize: number;\n
    foatingCircle: number;\n
  }`;
  let planType;
  if (groupPlan?.planId == 4) {
    planType = "team";
  } else if (groupPlan?.planId == 5) {
    planType = "business";
  } else {
    planType = "pro";
  }

  let orgFilterFlag = false;
  try {
    const orgIdToFilterList = process.env?.REACT_APP_FILTERED_ORG_IDS_COLLECTION
      ? JSON.parse(process.env.REACT_APP_FILTERED_ORG_IDS_COLLECTION)
      : [];
    orgFilterFlag = orgIdToFilterList?.includes(JSON.parse(userDetails?.id));
  } catch {
    orgFilterFlag = false;
  }

  const selectStartDate = (dateValue) => {
    const tempStartDate = moment(dateValue, "YYYY-MM-DD HH:mm:ss").format(
      "YYYY-MM-DD"
    );
    setStartDate(moment(tempStartDate, "YYYY-MM-DD").utc().format());
  };

  const selectEndDate = (dateValue) => {
    const tempEndDate = moment(dateValue, "YYYY-MM-DD HH:mm:ss")
      .add(1, "days")
      .format("YYYY-MM-DD");
    setEndDate(moment(tempEndDate, "YYYY-MM-DD").utc().format());
  };

  const exportLog = async () => {
    if (
      !dateFilter &&
      !(moment(startDate).isValid() && moment(endDate).isValid())
    ) {
      dispatch(
        notify("error", "Please select either a date range or checkbox")
      );
    } else {
      let dateQuery = "";
      if (!dateFilter) {
        if (moment(startDate).isValid() && moment(endDate).isValid()) {
          dateQuery = `&fromDate=${startDate}&toDate=${endDate}`;
        }
      }

      const exportLogResponse = orgFilterFlag
        ? await exportCollection(exportCsvName, dateQuery)
        : await exportCollectionV2(exportCsvName, dateQuery);

      if (exportLogResponse?.data == "No data found ") {
        dispatch(notify("error", "No data found"));
      } else {
        const url = window.URL.createObjectURL(
          new Blob([exportLogResponse.data])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${exportCsvName}.csv`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);

        dispatch(notify("success", "Collection logs exported"));
      }
    }
  };

  const removeCollection = async () => {
    setLoading(true);
    const deleteResponse = orgFilterFlag
      ? await deleteCollection(collectionName)
      : await deleteCollectionV2(collectionName, planType);
    if (deleteResponse?.data?.status == "OK") {
      history.push(`/dashboard/skills/collections`);
      dispatch(notify("success", deleteResponse?.data?.message));
    } else {
      dispatch(notify("error", deleteResponse?.data?.message));
    }
    setLoading(false);
  };

  const updateCollectionDetails = async () => {
    setIsEditing(true);
    let collectionData = {};
    collectionData["collectionName"] = editData?.name;
    collectionData["description"] = collectionDescription
      ? collectionDescription
      : editData?.description;
    collectionData["response_language"] = resposeLang
      ? resposeLang
      : editData?.response_language;

    collectionData["model"] = model ? model : editData?.model;
    collectionData["urls"] = editData?.url;
    collectionData["password"] = password;


    let _update = await updateCollection(collectionData);
    if (_update?.data?.status == "OK") {
      setIsEditing(false);
      $(".close").click();
      setCollectionName("");
      setCollectionDescription("");
      setModel("");
      setResponseLang("");

      dispatch(notify("success", "Updated Successfully"));
      history.push("/dashboard/skills/collections");
    } else {
      setIsEditing(false);
      dispatch(notify("error", "Something went wrong"));
    }
  };

  const newCollection = async () => {
    setIsLoading(true);
    let collectionData = {};
    collectionData["name"] = collectionName;
    collectionData["collectionDescription"] = collectionDescription;
    collectionData["response_language"] = resposeLang;

    // Check for special characters except underscore
  const specialCharsRegex = /[!@#\$%^&*()+\=$$$${};':"\\|,.<>/?]+/;
  
  if (specialCharsRegex.test(collectionName)) {
    dispatch(notify("error", "Collection name contains invalid special characters"));
    setIsLoading(false);
    return;
  }


    const regex = /^[a-zA-Z0-9_]+$/; // all alphanumeric values and _ only allowed
    const isCollectionNameValid = regex.test(collectionName);

    if (isCollectionNameValid) {
      if (selectedOption === "database") {
        if (!hostName || !userName || !password || !port || !databaseName || (advancedSettings && dbSchemas?.length < 1)) {
          dispatch(notify("error", "All fields are required."));
          setIsLoading(false);
          return;
        }
      }
      if (
  selectedOption === "live_search" &&
  selectedLiveSearch === "web_scrape" &&
  (liveSearchUrl.length === 0 || liveSearchUrl.some(url => url.trim() === ""))
) {
        dispatch(notify("error", "URL Cannot be empty for web scrape"));
        setIsLoading(false);
        return;
      }
      let createResponse;
      if (orgFilterFlag) {
        createResponse = await createCollection(collectionData);
      } else {
        collectionData["planType"] = planType;
        collectionData["baseLanguage"] = baseLanguage;
        collectionData["model"] = model;
        collectionData["source"] = selectedOption;
        collectionData["urls"] = liveSearchUrl;
        collectionData["selectedLiveSearch"] = selectedLiveSearch;

        let sourceSetting;
        if(advancedSettings){
          sourceSetting = {
            hostname: hostName,
            username: userName,
            password: password,
            databaseName: databaseName,
            port: port,
            isSSL: isSSL,
            databaseType:databaseType,
            db_schemas:dbSchemas.split(",")
          };
          if(advancedSettingsOption == 1){
            sourceSetting.use_tables = useTablesList.split(",")
            sourceSetting.use_views = useViewsList.split(",")
          }else{
            sourceSetting.neglect_view = neglectViewList.split(",")
            sourceSetting.neglect_table = neglectTableList.split(",")
          }
        }else{
        sourceSetting = {
          hostname: hostName,
          username: userName,
          password: password,
          databaseName: databaseName,
          port: port,
          isSSL: isSSL,
          databaseType:databaseType
        };
      }
        collectionData["source_setting"] = JSON.stringify(
          sourceSetting,
          null,
          2
        );
        createResponse = await createCollectionV2(collectionData);
      }

      const collection = await getCollectionsV2();

        const name = collection.response[0].name;
        const orgId = name.split("_")[0]; 

      if (createResponse?.data?.status == "OK") {
        $(".modal-backdrop").hide();
        if(selectedOption == "transcribe"){
          history.push(
            `/transcribe?name=${userDetails?.id}_${collectionName}`
          );
        } else{
        orgFilterFlag
          ? history.push(`/collections?name=${orgId}_${collectionName}`)
          : history.push(
            `/collectionWorkspace?name=${orgId}_${collectionName}`
          )
        }
        dispatch(notify("success", createResponse?.data?.message));
      } else {
        dispatch(notify("error", createResponse?.data?.message));
      }
    } else {
      dispatch(
        notify(
          "error",
          "Collection Name contains invalid characters. Please use only letters, digits, and underscores."
        )
      );
    }
    setIsLoading(false);
  };

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    setSelectedOption(newValue);
  };
  const handleLiveSearchRadioChange = (event) => {
    const newValue = event.target.value;
    setSelectedLiveSearch(newValue);
  };

   const handleLiveSearchUrl = (value, index) => {
     const newUrls = [...liveSearchUrl];
     newUrls[index] = value;
     setLiveSearchUrl(newUrls); // Update the corresponding URL
   };

    const handleAddUrl = () => {
      setLiveSearchUrl([...liveSearchUrl, ""]); // Add a new empty input field
    };

    const handleDeleteUrl = (index) => {
      const newUrls = liveSearchUrl.filter((_, i) => i !== index); // Remove the selected URL
      setLiveSearchUrl(newUrls);
    };
   


    const handleEditUrlChange = (value, index) => {
      const updatedUrls = JSON.parse(editData?.url || "[]");
      updatedUrls[index] = value; // Update the specific URL at the given index
      setEditData({ ...editData, url: JSON.stringify(updatedUrls) });
    };
    const handleAddEditUrl = () => {
      const updatedUrls = JSON.parse(editData.url);
      updatedUrls.push(""); // Add a new empty URL
      setEditData({ ...editData, url: JSON.stringify(updatedUrls) }); // Update state
    };

    const handleDeleteEditUrl = (index) => {
      const updatedUrls = JSON.parse(editData.url);
      updatedUrls.splice(index, 1); // Remove the URL at the specified index
      setEditData({ ...editData, url: JSON.stringify(updatedUrls) }); // Update state
    };

  useEffect(() => {
    setDateFilter(false);
    const fetchData = async () => {
      setLoading(true);
      let data;
      let models;
      if (orgFilterFlag) {
        data = await getCollections();
        data = data?.response;
      } else {
        models = await getListModels();
        data = await getCollectionsV2();
        data = data?.response;
        setListModels(models);
      }

      setLoading(false);
      if (data && data.length > 0) {
        setCollections(data);
      }
      dispatch(getAllApiTokens()).then(() => {
        setTokenFlag(true);
      });
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (token == undefined && tokenFlag) {
      dispatch(generateApiAccessToken()).then(() => {
        dispatch(getAllApiTokens());
      });
    }
  }, [tokenFlag]);

  const onChangecheck = (e) => {
    e.target.checked ? setDateFilter(true) : setDateFilter(false);
  };

  const items = [
    {
      label: (
        // <FacebookShareButton>
        //   <img src={facebook} />
        // </FacebookShareButton>
        <div
          className="date-select-csv"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Space direction="vertical">
            <label>Start Date</label>
            <DatePicker onChange={(date) => selectStartDate(date)} />
            <label>End Date</label>
            <DatePicker onChange={(date) => selectEndDate(date)} />
            <Checkbox onChange={onChangecheck}>Export Everything</Checkbox>
            <Button
              onClick={(e) => {
                exportLog();
              }}
              type="primary"
              icon={<DownloadOutlined />}
            >
              Export CSV
            </Button>
          </Space>
        </div>
      ),
      key: "0",
    },
    // {
    //   label: (
    //     <TwitterShareButton>
    //       <img src={twitter} />
    //     </TwitterShareButton>
    //   ),
    //   key: "1",
    // },
    // {
    //   label: (
    //     <LinkedinShareButton>
    //       <img src={linkedin} />
    //     </LinkedinShareButton>
    //   ),
    //   key: "3",
    // },
  ];

  useEffect(() => {
    window.$('[data-toggle="popover"]').popover({
      container: "body",
    });
  });

  const [open, setOpen] = useState(false);

  const columns = [
    {
      title: "Parameter",
      dataIndex: "parameter",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Default Value",
      dataIndex: "value",
    },
  ];
  const data = [
    {
      key: "1",
      parameter: "chatFontSize",
      type: "string",
      value: "12px",
    },
    {
      key: "2",
      parameter: "userChatBgColor",
      type: "string",
      value: "#1d262e",
    },
    {
      key: "3",
      parameter: "botChatBgColor",
      type: "string",
      value: "#f2f5f6",
    },
    {
      key: "4",
      parameter: "brandColor",
      type: "string",
      value: "#1d262e",
    },
    {
      key: "5",
      parameter: "greetingMsg",
      type: "string",
      value: "Text...",
    },
    {
      key: "6",
      parameter: "userIcon",
      type: "string",
      value: "Icon_URL",
    },
    {
      key: "7",
      parameter: "botIcon",
      type: "string",
      value: "Icon_URL",
    },
    {
      key: "8",
      parameter: "accentColor",
      type: "string",
      value: "#02ce9d",
    },
    {
      key: "9",
      parameter: "brandIcon",
      type: "string",
      value: "Icon_URL",
    },
    {
      key: "10",
      parameter: "headerMsg1",
      type: "string",
      value: "Text....",
    },
    {
      key: "11",
      parameter: "headerMsg2",
      type: "string",
      value: "Text....",
    },
    {
      key: "12",
      parameter: "headerMsg1Color",
      type: "string",
      value: "gray",
    },
    {
      key: "13",
      parameter: "headerMsg2Color",
      type: "string",
      value: "#fff",
    },
    {
      key: "14",
      parameter: "userFontColor",
      type: "string",
      value: "#fff",
    },
    {
      key: "15",
      parameter: "botFontColor",
      type: "string",
      value: "#1d262e",
    },
    {
      key: "16",
      parameter: "floatingIcon",
      type: "string",
      value: "Icon_URL",
    },
    {
      key: "17",
      parameter: "showUserIcon",
      type: "boolean",
      value: "false",
    },
    {
      key: "18",
      parameter: "showBotIcon",
      type: "boolean",
      value: "true",
    },
    {
      key: "19",
      parameter: "userIconBgColor",
      type: "string",
      value: "transparent",
    },
    {
      key: "20",
      parameter: "botIconBgColor",
      type: "string",
      value: "transparent",
    },
    {
      key: "21",
      parameter: "userIconPadding",
      type: "string",
      value: "none",
    },
    {
      key: "22",
      parameter: "botIconPadding",
      type: "string",
      value: "none",
    },
    {
      key: "23",
      parameter: "showBrandBorder",
      type: "boolean",
      value: "undefined",
    },
    {
      key: "24",
      parameter: "chatWidgetMinHeight",
      type: "string",
      value: "350px",
    },
    {
      key: "25",
      parameter: "chatWidgetMaxHeight",
      type: "string",
      value: "350px",
    },
    {
      key: "26",
      parameter: "chatWidgetCloseIconColor",
      type: "string",
      value: "#1d262e",
    },
    {
      key: "27",
      parameter: "chatBackgroundColor",
      type: "string",
      value: "#ffffff",
    },
    {
      key: "28",
      parameter: "chatWidgetWidth",
      type: "string",
      value: "400",
    },
    {
      key: "29",
      parameter: "typingMsg",
      type: "string",
      value: "Text....",
    },
    {
      key: "30",
      parameter: "floatingIconSize",
      type: "number",
      value: "28",
    },
    {
      key: "31",
      parameter: "floatingCircle",
      type: "number",
      value: "40",
    },
  ];

  const [openPL, setOpenPL] = useState(false);
  const showDrawer = () => {
    setOpenPL(true);
  };
  const onClose = () => {
    setOpenPL(false);
  };

  const handleCancel = () => {
    setSelectedOption("files");
    setCollectionDescription("");
    setCollectionName("");
    setModel("");
    setResponseLang(null);
  };

  const isCollectionInfoFilled = () => {
    return collectionName.trim() !== "" && collectionDescription.trim() !== "";
  };

  const EditModal = () => {
    return (
      <div
        id="editModal"
        className="modal fade crt-skill"
        role="dialog"
        data-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content crt-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => {
                  setIsEditing(false);
                  setEditData(null);
                  setCollectionName("");
                  setCollectionDescription("");
                  setModel("");
                }}
              >
                &times;
              </button>
              <h4 className="modal-title">
                Edit {editData?.name?.slice(editData.name.indexOf("_") + 1)}
              </h4>
            </div>
            <div className="modal-body">
              <form className="form-contain" action="javascript:void(0)">
                <div className="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label">
                      Name
                      <a
                        className="tlt-icon tl-tooltip task-table-info"
                        href="javascript:void(0)"
                        data-toggle="popover"
                        data-html="true"
                        data-trigger="hover"
                        data-placement="auto top"
                      >
                        <img src={info} alt="" />
                      </a>
                    </span>
                    <input
                      type="text"
                      name="name"
                      defaultValue={editData?.name?.slice(
                        editData.name.indexOf("_") + 1
                      )}
                      disabled
                    />
                  </div>
                </div>
                <div className="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label">Description</span>
                    <input
                      type="text"
                      name="description"
                      placeholder="Enter Description"
                      onChange={(e) => setCollectionDescription(e.target.value)}
                      defaultValue={editData?.description}
                    />
                  </div>
                </div>
                <div class="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label">Model</span>
                    <select value={model} onChange={(e) => setModel(e.target.value)}>
                    {listModels?.length > 0 ? 
                                 listModels.map((obj, ind) => {
                                  return <option value={obj}>{obj}</option>
                                 }) : null
                    }
                    </select>
                  </div>
                </div>

                {/* Response Lang */}
                {/* <div class="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label">Response Language</span>
                    <select onChange={(e) => setResponseLang(e.target.value)}>
                      {" "}
                      <option
                        value="en"
                        selected={
                          editData?.response_language == "en" ? true : false
                        }
                      >
                        English
                      </option>
                      <option
                        value="hi"
                        selected={
                          editData?.response_language == "hi" ? true : false
                        }
                      >
                        Hindi
                      </option>
                      <option
                        value="gom"
                        selected={
                          editData?.response_language == "gom" ? true : false
                        }
                      >
                        Gom
                      </option>
                      <option
                        value="kn"
                        selected={
                          editData?.response_language == "kn" ? true : false
                        }
                      >
                        Kannada
                      </option>
                      <option
                        value="doi"
                        selected={
                          editData?.response_language == "doi" ? true : false
                        }
                      >
                        Dogri
                      </option>
                      <option
                        value="brx"
                        selected={
                          editData?.response_language == "brx" ? true : false
                        }
                      >
                        Bodo
                      </option>
                      <option
                        value="ur"
                        selected={
                          editData?.response_language == "ur" ? true : false
                        }
                      >
                        Urdu
                      </option>
                      <option
                        value="ta"
                        selected={
                          editData?.response_language == "ta" ? true : false
                        }
                      >
                        Tamil
                      </option>
                      <option
                        value="ks"
                        selected={
                          editData?.response_language == "ks" ? true : false
                        }
                      >
                        Kashmiri
                      </option>
                      <option
                        value="as"
                        selected={
                          editData?.response_language == "as" ? true : false
                        }
                      >
                        Assamese
                      </option>
                      <option
                        value="bn"
                        selected={
                          editData?.response_language == "bn" ? true : false
                        }
                      >
                        Bengali
                      </option>
                      <option
                        value="mr"
                        selected={
                          editData?.response_language == "mr" ? true : false
                        }
                      >
                        Marathi
                      </option>
                      <option
                        value="sd"
                        selected={
                          editData?.response_language == "sd" ? true : false
                        }
                      >
                        Sindhi
                      </option>
                      <option
                        value="mai"
                        selected={
                          editData?.response_language == "mai" ? true : false
                        }
                      >
                        Maithili
                      </option>
                      <option
                        value="pa"
                        selected={
                          editData?.response_language == "pa" ? true : false
                        }
                      >
                        Punjabi
                      </option>
                      <option
                        value="ml"
                        selected={
                          editData?.response_language == "ml" ? true : false
                        }
                      >
                        Malayalam
                      </option>
                      <option
                        value="te"
                        selected={
                          editData?.response_language == "te" ? true : false
                        }
                      >
                        Telugu
                      </option>
                      <option
                        value="sa"
                        selected={
                          editData?.response_language == "sa" ? true : false
                        }
                      >
                        Sanskrit
                      </option>
                      <option
                        value="ne"
                        selected={
                          editData?.response_language == "ne" ? true : false
                        }
                      >
                        Nepali
                      </option>
                      <option
                        value="sat"
                        selected={
                          editData?.response_language == "sat" ? true : false
                        }
                      >
                        Santali
                      </option>
                      <option
                        value="gu"
                        selected={
                          editData?.response_language == "gu" ? true : false
                        }
                      >
                        Gujarati
                      </option>
                      <option
                        value="or"
                        selected={
                          editData?.response_language == "or" ? true : false
                        }
                      >
                        Odia
                      </option>
                    </select>
                  </div>
                </div> */}

                {editData?.source === "database" && !orgFilterFlag ? (
                  <>
                    <div className="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">User Name</span>
                        <input
                          type="text"
                          placeholder="Enter User Name"
                          onChange={(e) => setUserName(e.target.value)}
                          disabled
                          defaultValue={editData?.source_setting?.username}
                        />
                      </div>
                    </div>
                    <div className="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">Password</span>
                        <input
                          type="text"
                          placeholder="Enter Password"
                          onChange={(e) => setPassword(e.target.value)}
                          defaultValue={editData?.source_setting?.password}
                        />
                      </div>
                    </div>
                    <div className="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">Port</span>
                        <input
                          type="text"
                          placeholder="Enter Port"
                          onChange={(e) => setPort(e.target.value)}
                          disabled
                          defaultValue={editData?.source_setting?.port}
                        />
                      </div>
                    </div>
                    <div className="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">Database Name</span>
                        <input
                          type="text"
                          placeholder="Enter Database Name"
                          onChange={(e) => setDatabaseName(e.target.value)}
                          disabled
                          defaultValue={editData?.source_setting?.databaseName}
                        />
                      </div>
                      <div className="ip-tl-label">
                        <span className="tl-label">Database Type</span>
                        <select
                          value={databaseType}
                          onChange={(e) => setDatabaseType(e.target.value)}
                          disabled
                        >
                          <option value="postresql" selected>
                            PostreSQL
                          </option>
                          <option value="mssql">MSSQL</option>
                          <option value="mysql">MySQL</option>
                          <option value="oracle">Oracle DB</option>
                        </select>
                      </div>
                      <Checkbox
                        onChange={(e) => setIsSSL(e.target.checked)}
                        checked={isSSL}
                        defaultChecked={editData?.source_setting?.isSSL}
                      >
                        SSL Enabled
                      </Checkbox>
                    </div>
                  </>
                ) : null}

                {editData?.source === "live_search" && !orgFilterFlag ? (
                  <>
                    <div className="frm-block">
                      <div className="ip-tl-label text-black">
                        <label>
                          <input
                            type="radio"
                            name="liveSearchOption"
                            value="web_scrape"
                            checked={editData?.search_type === "web_scrape"}
                            disabled
                          />
                          Web Scraping
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="liveSearchOption"
                            value="web_search"
                            checked={editData?.search_type === "web_search"}
                            disabled
                          />
                          Web Search
                        </label>
                      </div>

                      <div className="url-inputs">
                        {!editData?.url || editData?.url === "[]" ? (
                          <div className="flex-ip-label">
                            <div className="ip-tl-label">
                              <span className="tl-label">URL</span>
                              <input
                                type="url"
                                name={`editLiveSearchUrl0`}
                                placeholder="Enter URL"
                                value={""}
                                onChange={(e) =>
                                  handleEditUrlChange(e.target.value, 0)
                                }
                                required={
                                  editData?.search_type === "web_scrape"
                                }
                              />
                            </div>
                            <Tooltip title="Add New URL">
                              <Button
                                type="primary"
                                icon={<PlusCircleOutlined />}
                                onClick={handleAddEditUrl}
                                disabled={
                                  JSON.parse(editData?.url || "[]").length >= 5
                                }
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          // If URLs are present, iterate and show the input fields
                          JSON.parse(editData.url).map((url, index) => (
                            <div className="flex-ip-label" key={index}>
                              <div className="ip-tl-label">
                                <span className="tl-label">URL</span>
                                <input
                                  type="url"
                                  name={`editLiveSearchUrl${index}`}
                                  placeholder="Enter URL"
                                  value={url || ""} // Display the current URL or empty string
                                  onChange={(e) =>
                                    handleEditUrlChange(e.target.value, index)
                                  } // Handle URL change
                                  required={
                                    editData?.search_type === "web_scrape"
                                  }
                                />
                              </div>
                              <Tooltip title="Add New URL">
                                <Button
                                  type="primary"
                                  icon={<PlusCircleOutlined />}
                                  onClick={handleAddEditUrl}
                                  disabled={
                                    JSON.parse(editData?.url || "[]").length >=
                                    5
                                  }
                                />
                              </Tooltip>
                              {JSON.parse(editData.url).length > 1 && (
                                <Tooltip title="Delete URL">
                                  <Button
                                    type="danger"
                                    danger
                                    icon={
                                      <DeleteTwoTone twoToneColor="#fd2000" />
                                    }
                                    onClick={() => handleDeleteEditUrl(index)} // Delete URL input field
                                  />
                                </Tooltip>
                              )}
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                <div className="frm-btns">
                  <button
                    className="btn btn-outline"
                    data-dismiss="modal"
                    onClick={() => {
                      setIsEditing(false);
                      setEditData(null);
                      setCollectionName("");
                      setCollectionDescription("");
                      setModel("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    class="btn btn-primary"
                    onClick={() => updateCollectionDetails()}
                  >
                    {isEditing ? (
                      <div class="sp sp-circle text-light"></div>
                    ) : (
                      "Update"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <Loader
        styles={{ width: "80px", margin: "auto" }}
        root={{ display: "flex" }}
      />
    );
  } else {
    return (
      <div className="template-flex">
        <div className="template-box scrollable">
          <div
            id="inviteModal1"
            className="modal fade crt-skill"
            role="dialog"
            data-keyboard="false"
          >
            <div className="modal-dialog">
              <div className="modal-content crt-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    onClick={() => handleCancel()}
                  >
                    &times;
                  </button>
                  <div className="modal-title-flex">
                    <h4 class="modal-title"> Create collection</h4>
                    <div class="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">Collection Type</span>
                        <select
                          value={selectedOption}
                          onChange={handleSelectChange}
                        >
                          <option value="files" selected>
                            Unstructured Data(Files)
                          </option>
                          <option value="database">Database</option>
                          <option value="live_search">Live Search</option>
                          <option value="transcribe">Transcribe</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-body">
                  <form className="form-contain" action="javascript:void(0)">
                    {/* <div className="frm-block">
                      <label>Data Source</label>
                      <div className="ip-tl-label text-black">
                        <label>
                          <input
                            type="radio"
                            name="dataOption"
                            value="files"
                            checked={selectedOption === "files"}
                            onChange={handleRadioChange}
                          />
                          Unstructured Data (Files)
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="dataOption"
                            value="database"
                            checked={selectedOption === "database"}
                            onChange={handleRadioChange}
                            // disabled={!isCollectionInfoFilled()}
                          />
                          Database
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="dataOption"
                            value="live_search"
                            checked={selectedOption === "live_search"}
                            onChange={handleRadioChange}
                            // disabled={!isCollectionInfoFilled()}
                          />
                          Live Search
                        </label>
                      </div>
                    </div> */}

                    {(selectedOption === "files" ||
                      selectedOption === "transcribe") && (
                      <>
                        <div className="frm-block">
  <div className="ip-tl-label">
    <span className="tl-label">
      Name
      <a
        className="tlt-icon tl-tooltip task-table-info"
        href="javascript:void(0)"
        data-toggle="popover"
        data-html="true"
        data-trigger="hover"
        data-placement="auto top"
        data-content="Collection name must be globally unique and must start with a letter."
      >
        <img src={info} alt="" />
      </a>
    </span>
    <input
      type="text"
      name="name"
      value={collectionName}
      placeholder="Enter your collection name"
      onChange={(e) => {
        const value = e.target.value;
        // Regular expression to check for special characters except underscore
        const specialCharsRegex = /[!@#\$%^&*()+\=$$$${};':"\\|,.<>/?]+/;
        
        if (specialCharsRegex.test(value)) {
          setNameError("Special characters are not allowed except underscore (_)");
        } else {
          setNameError("");
        }
        setCollectionName(value);
      }}
    />
    {nameError && (
      <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
        {nameError}
      </div>
    )}
  </div>
</div>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">Description</span>
                            <input
                              type="text"
                              name="description"
                              placeholder="Enter Description"
                              onChange={(e) =>
                                setCollectionDescription(e.target.value)
                              }
                            />
                          </div>
                        </div>

                        {selectedOption !== "database" && !orgFilterFlag ? (
                          <div class="frm-block">
                            <div className="ip-tl-label">
                              <span className="tl-label">Model</span>
                              <select
                                onChange={(e) => setModel(e.target.value)}
                              >
                                {listModels?.length > 0 ? 
                                 listModels.map((obj, ind) => {
                                  return <option value={obj}>{obj}</option>
                                 }) : null
                                }
                              </select>
                            </div>
                          </div>
                        ) : null}

                        {selectedOption !== "database" &&
                        selectedOption !== "transcribe" &&
                        !orgFilterFlag ? (
                          <div class="frm-block">
                            <div className="ip-tl-label">
                              <span className="tl-label">
                                Base Language
                                <a
                                  class="tlt-icon tl-tooltip task-table-info"
                                  href="javascript:void(0)"
                                  data-toggle="popover"
                                  data-html="true"
                                  data-trigger="hover"
                                  data-placement="auto top"
                                  data-content="Supervity Collection requires that the documents being uploaded are in the base language script. Therefore, please ensure to upload your documents in the base language selected for better accuracy."
                                >
                                  <img src={info} alt="" />
                                </a>
                              </span>
                              <select
                                onChange={(e) =>
                                  setBaseLanguage(e.target.value)
                                }
                              >
                                <option value="en" selected>
                                  English
                                </option>
                                <option value="es">Spanish</option>
                                <option value="ja">Japanese</option>
                              </select>
                            </div>
                          </div>
                        ) : null}
                      </>
                    )}
                    {selectedOption === "database" && (
                      <>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">
                              Name
                              <a
                                className="tlt-icon tl-tooltip task-table-info"
                                href="javascript:void(0)"
                                data-toggle="popover"
                                data-html="true"
                                data-trigger="hover"
                                data-placement="auto top"
                                data-content="Collection name must be globally unique and must start with a letter."
                              >
                                <img src={info} alt="" />
                              </a>
                            </span>
                            <input
                              type="text"
                              name="name"
                              placeholder="Enter your collection name"
                              onChange={(e) =>
                                setCollectionName(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">Description</span>
                            <input
                              type="text"
                              name="description"
                              placeholder="Enter Description"
                              onChange={(e) =>
                                setCollectionDescription(e.target.value)
                              }
                            />
                          </div>
                        </div>

                        <div className="ip-tl-label">
                            <span className="tl-label">Database Type</span>
                            <select onChange={(e) => setDatabaseType(e.target.value)}>
                              <option value="postresql" selected>PostreSQL</option>
                              <option value="mssql">
                                MSSQL
                              </option>
                              <option value="mysql">MySQL</option>
                              <option value="oracle">Oracle DB</option>
                            </select>
                          </div>

                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">Database Host Name</span>
                            <input
                              type="text"
                              placeholder="Enter Host Name"
                              onChange={(e) => setHostName(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">User Name</span>
                            <input
                              type="text"
                              placeholder="Enter User Name"
                              onChange={(e) => setUserName(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">Password</span>
                            <input
                              type="text"
                              placeholder="Enter Password"
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">Port</span>
                            <input
                              type="text"
                              placeholder="Enter Port"
                              onChange={(e) => setPort(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">Database Name</span>
                            <input
                              type="text"
                              placeholder="Enter Database Name"
                              onChange={(e) => setDatabaseName(e.target.value)}
                              required
                            />
                          </div>
                          <Checkbox
                            onChange={(e) => setIsSSL(e.target.checked)}
                            checked={isSSL}
                          >
                            SSL Enabled
                          </Checkbox>
                        </div>

                        {selectedOption !== "files" && !orgFilterFlag ? (
                          <div class="frm-block">
                            <div className="ip-tl-label">
                              <span className="tl-label">Model</span>
                              <select
                                onChange={(e) => setModel(e.target.value)}
                              >
                                {listModels?.length > 0 ? 
                                 listModels.map((obj, ind) => {
                                  return <option value={obj}>{obj}</option>
                                 }) : null
                                }
                              </select>
                            </div>
                          </div>
                        ) : null}
                      
                      <Checkbox
                            onChange={(e) => setAdvancedSettings(e.target.checked)}
                            checked={advancedSettings}
                          >
                            Advanced Settings
                          </Checkbox>

                          {advancedSettings ? (
                            <>
                            <div className="ip-tl-label">
                            <span className="tl-label">DB Schemas</span>
                            <input
                              type="text"
                              placeholder="Eg: Schema1,Schema2"
                              onChange={(e) => setDbSchemas(e.target.value)}
                              required
                            />
                          </div>

                             <div className="frm-block">

                             <Checkbox
                            onChange={(e) => setAdvancedSettingsOption(1)}
                            checked={advancedSettingsOption == 1}
                          >
                            Use
                          </Checkbox>
                             <Checkbox
                            onChange={(e) => setAdvancedSettingsOption(2)}
                            checked={advancedSettingsOption == 2}
                          >
                            Neglect
                          </Checkbox>
                              </div>
                          
                          { advancedSettingsOption == 1 ? (
                            <>
                            <div className="frm-block">
                              <div className="ip-tl-label">
                                <span className="tl-label">Use Tables</span>
                                <input
                                  type="text"
                                  placeholder="Eg: value1, value2"
                                  onChange={(e) => setUseTablesList(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="frm-block">
                              <div className="ip-tl-label">
                                <span className="tl-label">Use Views</span>
                                <input
                                  type="text"
                                  placeholder="Eg: value1, value2"
                                  onChange={(e) => setUseViewsList(e.target.value)}
                                />
                              </div>
                            </div>
                          </>
                          ) : 
                          (
                            <>
                            <div className="frm-block">
                              <div className="ip-tl-label">
                                <span className="tl-label">Neglect view</span>
                                <input
                                  type="text"
                                  placeholder="Eg: value1, value2"
                                  onChange={(e) => setNeglectViewList(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="frm-block">
                              <div className="ip-tl-label">
                                <span className="tl-label">Neglect table</span>
                                <input
                                  type="text"
                                  placeholder="Eg: value1, value2"
                                  onChange={(e) => setNeglectTableList(e.target.value)}
                                />
                              </div>
                            </div>
                          </>
                          )}
                          </>
                          ) : null}

                      </>

                      
                    )}
                    {!orgFilterFlag && selectedOption === "live_search" ? (
                      <>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">
                              Name
                              <a
                                className="tlt-icon tl-tooltip task-table-info"
                                href="javascript:void(0)"
                                data-toggle="popover"
                                data-html="true"
                                data-trigger="hover"
                                data-placement="auto top"
                                data-content="Collection name must be globally unique and must start with a letter."
                              >
                                <img src={info} alt="" />
                              </a>
                            </span>
                            <input
                              type="text"
                              name="name"
                              placeholder="Enter your collection name"
                              onChange={(e) =>
                                setCollectionName(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="frm-block">
                          <div className="ip-tl-label">
                            <span className="tl-label">Description</span>
                            <input
                              type="text"
                              name="description"
                              placeholder="Enter Description"
                              onChange={(e) =>
                                setCollectionDescription(e.target.value)
                              }
                            />
                          </div>
                        </div>

                        {selectedOption !== "database" &&
                        selectedOption !== "files" &&
                        !orgFilterFlag ? (
                          <div class="frm-block">
                            <div className="ip-tl-label">
                              <span className="tl-label">Model</span>
                              <select
                                onChange={(e) => setModel(e.target.value)}
                              >
                                {listModels?.length > 0 ? 
                                 listModels.map((obj, ind) => {
                                  return <option value={obj}>{obj}</option>
                                 }) : null
                                }
                              </select>
                            </div>
                          </div>
                        ) : null}

                        <div className="frm-block">
                          <div className="ip-tl-label text-black">
                            <label>
                              <input
                                type="radio"
                                name="liveSearchOption"
                                value="web_scrape"
                                checked={selectedLiveSearch === "web_scrape"}
                                onChange={handleLiveSearchRadioChange}
                              />
                              Web Scraping
                            </label>
                            {/* <label>
                              <input
                                type="radio"
                                name="liveSearchOption"
                                value="web_search"
                                checked={selectedLiveSearch === "web_search"}
                                onChange={handleLiveSearchRadioChange}
                              />
                              Web Search
                            </label> */}
                          </div>

                          <div className="frm-block">
                            {liveSearchUrl.map((url, index) => (
                              <div className="flex-ip-label" key={index}>
                                <div className="ip-tl-label">
                                  <span className="tl-label">URL</span>
                                  <input
                                    type="url"
                                    name={`liveSearchUrl${index}`}
                                    placeholder="Enter URL"
                                    value={url}
                                    onChange={(e) =>
                                      handleLiveSearchUrl(e.target.value, index)
                                    }
                                    required={
                                      selectedLiveSearch === "web_scrape"
                                    } // Add required only for Web Scraping
                                  />
                                </div>
                                {/* <Tooltip title="Add New URL">
                                  <Button
                                    type="primary"
                                    icon={<PlusCircleOutlined />}
                                    onClick={handleAddUrl}
                                    disabled={liveSearchUrl.length >= 5}
                                  />
                                </Tooltip> */}
                                {liveSearchUrl.length > 1 && (
                                  <Tooltip title="Delete URL">
                                    <Button
                                      type="danger"
                                      danger
                                      icon={
                                        <DeleteTwoTone twoToneColor="#fd2000" />
                                      }
                                      onClick={() => handleDeleteUrl(index)}
                                    />
                                  </Tooltip>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    ) : null}
                          
                    {/* Respone Language */}
                    {/* <div class="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">Response Language</span>
                        <select
                          onChange={(e) => setResponseLang(e.target.value)}
                        >
                          <option value="en" selected>
                            English
                          </option>
                          <option value="hi">Hindi</option>
                          <option value="gom">Gom</option>
                          <option value="kn">Kannada</option>
                          <option value="doi">Dogri</option>
                          <option value="brx">Bodo</option>
                          <option value="ur">Urdu</option>
                          <option value="ta">Tamil</option>
                          <option value="ks">Kashmiri</option>
                          <option value="as">Assamese</option>
                          <option value="bn">Bengali</option>
                          <option value="mr">Marathi</option>
                          <option value="sd">Sindhi</option>
                          <option value="mai">Maithili</option>
                          <option value="pa">Punjabi</option>
                          <option value="ml">Malayalam</option>
                          <option value="te">Telugu</option>
                          <option value="sa">Sanskrit</option>
                          <option value="ne">Nepali</option>
                          <option value="sat">Santali</option>
                          <option value="gu">Gujarati</option>
                          <option value="or">Odia</option>
                        </select>
                      </div>
                    </div> */}
                    <div className="frm-btns">
                      <button
                        className="btn btn-outline"
                        data-dismiss="modal"
                        onClick={() => handleCancel()}
                      >
                        Cancel
                      </button>
                      <button
                        class="btn btn-primary"
                        onClick={() => newCollection()}
                        disabled={nameError}
                      >
                        {isLoading ? (
                          <div class="sp sp-circle text-light"></div>
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="tp-title flex-title">
            <h3>Collections</h3>
            {userDetails?.role_id == "2" ? (
              <div className="rt-btns">
                <button
                  className="btn btn-primary btn-black"
                  data-toggle="modal"
                  data-target="#inviteModal1"
                >
                  + Collection
                </button>
              </div>
            ) : null}
          </div>

          <div
            className="modal fade qa-modal1"
            id="collectionDeleteModal"
            role="dialog"
          >
            <div className="modal-dialog modal-sm">
              <div className="modal-content share-modal">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <div className="modal-body">
                  <h3 className="qa-modal-title">Delete</h3>
                  <div>
                    <h5>Please confirm delete action.</h5>
                  </div>

                  <div className="frm-btns fb-right">
                    <button className="btn-outline" data-dismiss="modal">
                      Cancel
                    </button>
                    <button
                      className="btn-primary"
                      data-dismiss="modal"
                      onClick={() => {
                        removeCollection();
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {collections?.length > 0 ? (
            collections.map((obj, ind) => {
              let baseLanguageText = "English";
              if (!orgFilterFlag) {
                if (obj?.source == "transcribe") {
                  baseLanguageText = "Transcribe";
                } else {
                  if (obj?.base_language == "es") baseLanguageText = "Spanish";
                  else if (obj?.base_language == "ja")
                    baseLanguageText = "Japanese";
                  else baseLanguageText = "English";
                }
              }
              return (
                <div className="tp-boxes">
                  <div className="column">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                      <div className="cl-outer">
                        {/* {userDetails?.role_id == "2" ?
                        <Tooltip title="Delete">
                        <button 
                          className="cl-delete"
                          data-toggle="modal"
                          data-target="#collectionDeleteModal"
                          onClick={() => {
                            setCollectionName(obj.name);
                          }}  
                        >
                          <DeleteTwoTone twoToneColor="#fd2000" />
                        </button>
                        </Tooltip>                  
                      : null} */}

                        {userDetails?.role_id == "2" ? (
                          <div className="rtb-menu draft-menu cl-dropmenu">
                            <div class="dropdown">
                              <a
                                class="rtb-menu-btn"
                                type="button"
                                data-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img src={rtbmenu} />
                              </a>
                              <ul class="dropdown-menu dropdown-menu-left pull-right">
                                <li>
                                  <button
                                    onClick={() => {
                                      setCollectionName(obj.name);
                                      setOpen(true);
                                    }}
                                  >
                                    <span>
                                      <img src={embedIcon} />
                                    </span>
                                    Integration Options
                                  </button>
                                </li>
                                {/* edit collection */}
                                <li>
                                  <button
                                    data-toggle="modal"
                                    data-target="#editModal"
                                    onClick={() => {
                                      setModel(obj?.model)
                                      setEditData(obj);
                                    }}
                                  >
                                    <EditOutlined twoToneColor="#fd2000" /> Edit
                                  </button>
                                </li>
                                <li>
                                  <button
                                    data-toggle="modal"
                                    data-target="#collectionDeleteModal"
                                    onClick={() => {
                                      setCollectionName(obj.name);
                                    }}
                                  >
                                    <DeleteTwoTone twoToneColor="#fd2000" />{" "}
                                    Delete
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>
                        ) : null}

                        {/* Embed Modal */}
                        <Modal
                          title="Our Integration Options"
                          // centered
                          style={{ top: 20 }}
                          open={open}
                          onOk={() => setOpen(false)}
                          onCancel={() => setOpen(false)}
                          footer={null}
                          width={1000}
                        >
                          {/* <div className="row">
                            <div className="col-lg-6">
                              <div className="embedScreen-img">
                                <a
                                  href={embedImageOption1}
                                  target="_blank"
                                  rel="noreferrer noopener"
                                >
                                  <img src={embedImageOption1} />
                                </a>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="instruct-snp-list">
                                <h5>Option#1 :</h5>
                                <ul className="ist-block">
                                  <li>
                                    <span>01</span>
                                    <p>
                                      To enable AI powered conversational bot
                                      linked to this collection on your web
                                      application/portal as shown on the left
                                      side image, use the below JavaScript.
                                      <br />
                                      <code>
                                        &lt;script
                                        src=https://tfaisuper.blob.core.windows.net/$web/super.mjs?sa=
                                        {token}&amp;orgId={userDetails?.id}
                                        &amp;collection={collectionName}&amp;w
                                        type=module async&gt;&lt;/script&gt;
                                      </code>
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div> */}
                          {/* <hr /> */}
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="embedScreen-img">
                                <a
                                  href={embedImageOption2}
                                  target="_blank"
                                  rel="noreferrer noopener"
                                >
                                  <img src={embedImageOption2} />
                                </a>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="instruct-snp-list">
                                {/* <h5>Option#2 :</h5> */}
                                <ul className="ist-block">
                                  <li>
                                    <span>01</span>
                                    <p>
                                      To enable AI powered conversational bot
                                      linked to this collection on your web
                                      application/portal as shown on the left
                                      side image, use the below JavaScript.
                                      <br />
                                      <code>
                                        &lt;script
                                        src="https://{process.env.REACT_APP_PUBLIC_BUCKET}/$web/supervity-chat-widget.js?token=
                                        {token}&amp;orgId={userDetails?.id}
                                        &amp;collection={collectionName}"
                                        type=module async&gt;&lt;/script&gt;
                                      </code>
                                    </p>
                                  </li>
                                  <li>
                                    <span>02</span>
                                    <div className="table-data">
                                      <p>
                                        In addition to the token, orgId,
                                        collection you can also pass any of the
                                        keys as query parameters to the
                                        JavaScript as per your requirement.
                                        Please click on the below button to see
                                        the paramters list
                                        <br />
                                        {/* <code>{text}</code> */}
                                      </p>
                                      <button
                                        className="btn-table-data"
                                        onClick={showDrawer}
                                      >
                                        View Parameters List
                                      </button>
                                    </div>
                                  </li>
                                  <li>
                                    <span>03</span>
                                    <div>
                                      <p>Example for adding query parameter:</p>
                                      <ul className="inner-ol-list">
                                        <li>&chatFontSize=20px</li>
                                      </ul>
                                    </div>
                                  </li>
                                  <li>
                                    <span>04</span>
                                    <div>
                                      <p>
                                        The parameter values must be URI
                                        encoded. <br /> For Example:
                                      </p>
                                      <ul className="inner-ol-list">
                                        <li>
                                          Before URI encoding :{" "}
                                          <code>
                                            chatFontSize=20&chatBackgroundColor=#fd2000
                                          </code>
                                        </li>
                                        <li>
                                          After URI encoding :{" "}
                                          <code>
                                            chatFontSize=20&chatBackgroundColor=%23fd2000
                                          </code>
                                        </li>
                                      </ul>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <Drawer
                            width={500}
                            title="Parameter List"
                            onClose={onClose}
                            open={openPL}
                          >
                            <Table
                              pagination={false}
                              bordered
                              columns={columns}
                              dataSource={data}
                              size="small"
                            />
                          </Drawer>
                        </Modal>
                        {/* End of Embed Modal */}

                        <div
                          className="cl-block"
                          onClick={() => {
                            if (obj?.source == "transcribe") {
                              history.push(`/transcribe?name=${obj.name}`);
                            } else {
                              orgFilterFlag
                                ? history.push(
                                    `/collections?name=${obj.name}&c=${obj.num_entities}&doc=${obj?.documents}`,
                                    { documents: obj.documents }
                                  )
                                : history.push(
                                  `/collectionWorkspace?name=${obj.name}`
                                )
                            }
                          }}
                        >
                          {!orgFilterFlag ? (
                            <span className="lang-show">
                              {baseLanguageText}
                            </span>
                          ) : null}
                          <h4 className="cl-title" title={obj.name}>
                            {orgFilterFlag
                              ? obj.name
                              : obj.name?.slice(obj.name.indexOf("_") + 1)}
                          </h4>
                          <div className="cl-desc">
                            <p>
                              {obj.description == "undefined"
                                ? ""
                                : obj.description}
                            </p>
                          </div>
                          {/* <div className="cl-tags">
                          <ul>
                            <li style={{background: "#ffede0"}}>Document</li>
                            <li style={{background: "#e7eaef"}}>Note</li>
                            <li style={{background: "#cee3ff"}}>URL</li>
                          </ul>
                        </div> */}
                          {orgFilterFlag ? (
                            <h3 className="total-cl">
                              {obj.num_entities} <span>Entities</span>
                            </h3>
                          ) : null}
                        </div>
                        <div className="cl-footer">
                          <button
                            className="cl-btn-add"
                            onClick={() => {
                              orgFilterFlag
                                ? history.push(
                                    `/collections?name=${obj.name}&c=${obj.num_entities}&doc=${obj?.documents}`,
                                    { documents: obj.documents }
                                  )
                                : history.push(
                                  `/collectionWorkspace?name=${obj.name}`
                                )
                            }}
                          >
                            <span className="rounded-icon-plus">+</span>
                            View / Add
                          </button>
                          {/* <div className="dropdown ss-shareIco">
                          <Dropdown
                            className="share-skill"
                            arrow={{ pointAtCenter: true }}
                            menu={{
                              items,
                            }}
                            trigger={["click"]}
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                <img src={shareIcon} />
                              </Space>
                            </a>
                          </Dropdown>
                        </div> */}
                          <div className="dropdown ss-shareIco">
                            <Dropdown
                              className="share-skill"
                              // arrow={{ pointAtCenter: true }}
                              menu={{
                                items,
                              }}
                              trigger={["click"]}
                              placement="bottomRight"
                            >
                              <Tooltip title="Export CSV">
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setExportCsvName(obj?.name);
                                  }}
                                >
                                  <Space>
                                    <FileExcelFilled
                                      style={{ color: "#000" }}
                                    />
                                  </Space>
                                </a>
                              </Tooltip>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="empty-skill text-center">
              <img src={emptyIcon} />
              <p>No collections found</p>
              {userDetails?.role_id == "2" ? (
                <button
                  className="btn btn-primary btn-black"
                  data-toggle="modal"
                  data-target="#inviteModal1"
                >
                  + Create Collection
                </button>
              ) : null}
            </div>
          )}

          {EditModal()}
        </div>
      </div>
    );
  }
};
export default Collections;

